export interface UpdateBulkReserveExpirationRequest {
  reserves: {
    id: number
    revision: number
  }[]
  reserveExpiration: string
}

export function UpdateBulkReserveExpirationRequestToJSON(
  value: UpdateBulkReserveExpirationRequest
): any {
  return {
    reserves:
      value.reserves.length > 0
        ? value.reserves.map(reserve => {
            return {
              id: reserve.id !== 0 ? reserve.id : undefined,
              revision: reserve.revision !== 0 ? reserve.revision : undefined
            }
          })
        : undefined,
    reserve_expiration:
      value.reserveExpiration !== '' ? value.reserveExpiration : undefined
  }
}
